import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import React from 'react';
// import ReactPlayer from 'react-player';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';

import { DemoFormLong } from '../../../components/DemoFormLong.jsx';

class WistiaPlayer extends React.Component {

    componentDidMount  = () => {
		const script = document.createElement("script");
		script.src = "https://fast.wistia.com/embed/medias/w3z2ts8oug.jsonp";
		script.async = true;
		document.body.appendChild(script);

		const script2 = document.createElement("script");
		script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
		script2.async = true;

		document.body.appendChild(script2);	
	}


	render() {
		return (
            <div className="wistia_responsive_padding" style={{padding:"56.25% 0 0 0", margin: "0 0 20px 0", position:"relative", width:"100%"}}>
            <div className="wistia_responsive_wrapper" style={{height: "100%", left: "0", position: "absolute", top: "0", width: "100%"}}>
                <div className="wistia_embed wistia_async_w3z2ts8oug videoFoam=true" style={{height: "100%", position: "relative", width: "100%"}}>
                    <div className="wistia_swatch" style={{height:"100%", left:"0", opacity:"0", overflow:"hidden", position:"absolute", top:"0", transition:"opacity 200ms", width:"100%"}}>
                        <img src="https://fast.wistia.com/embed/medias/w3z2ts8oug/swatch" style={{filter:"blur(5px)", height:"100%", width:"100%"}} alt="Chart Example" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </div>

		);
	}
}

const Home = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;




    return (
        <Layout bodyClass="page-home" ontouchstart>
            <SEO title="ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Automatically create and update org charts, build headcount plans and analyze all your people data in one central hub, no spreadsheets needed."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Automatically create and update org charts, build headcount plans and analyze all your people data in one central hub, no spreadsheets needed." />
                <meta property="og:image" content={`https://www.charthop.com/landings/Scenario_RemoveOpenRole.gif`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Automatically create and update org charts, build headcount plans and analyze all your people data in one central hub, no spreadsheets needed." />
                <meta name="twitter:image" content={`https://www.charthop.com/landings/Scenario_RemoveOpenRole.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>
            {/* PAGE CONTENT */}
            <section className="intro container introductionVideoPage">
                <div className="row align-items-center">

                    {/* <div className="col-12 wistiaFormatTest" >
                        <ReactPlayer
                            url='https://home.wistia.com/medias/e4a27b971d'
                        />
                    </div> */}

         
                    


                        
                    <div className="introducing-charthop-video col-12">
                        <h1>ChartHop & Greenhouse Integration</h1>
                        <WistiaPlayer/>
                        <p className="pt-1 pb-1">ChartHop centralizes all of your people data from your HR tools to become your system of record. We then layer on top visualization and reporting features that help you analyze and track your organization evolution over time. </p><p>

                        

This all comes together in the first-of-it’s-kind scenario planning platform, where you can use all of this data to create plans for the future, with context. 
</p><p>

You can build: 
<li>annual headcount plans</li>
<li>ad-hoc headcount requests</li>
<li>team restructures</li>
<li>and so much more.</li>
</p><p>
The ChartHop & Greenhouse integration allows you to take those plans and put them into action.
</p>

                    </div>
                </div>
            </section>




            {/* CONTACT FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"resources-video-greenhouse-demo-bottom"} headertext={HtmlParser("<h1>See how ChartHop can help!</br></br> Request a demo now.</h1>")} focusID={HtmlParser("name")} />
            </section>

        </Layout>
    );
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;